export default "__VITE_ASSET__CRmEOBk6__"